var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }